import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { SwitchCell } from 'core/elements';
import { IProjectUser } from 'projects/types';

import { ActionsCell } from './cells';
import { SettingValue, SettingValueLabel, UserRole, UserRoleLabel } from './enums';

export const getColumnDefs = (projectId: number): ColDef[] => {
  return [
    {
      colId: 'actions',
      width: 80,
      maxWidth: 80,
      sortable: false,
      resizable: false,
      enableRowGroup: false,
      suppressColumnsToolPanel: true,
      pinned: 'left',
      lockPinned: true,
      cellRenderer: ActionsCell,
      cellRendererParams: {
        projectId,
      },
      flex: 1,
    },
    {
      colId: 'name',
      headerName: t('headerName'),
      field: 'name',
      filter: 'agTextColumnFilter',
      flex: 4,
    },
    {
      colId: 'isOwner',
      headerName: t('headerRole'),
      field: 'isOwner',
      filter: 'agSetColumnFilter',
      filterParams: {
        values: Object.values(UserRole),
        valueFormatter: ({ value }) => {
          return UserRoleLabel[value];
        },
      },
      valueGetter: ({ data }) => (data ? (data?.isOwner ? UserRole.OWNER : UserRole.USER) : null),
      valueFormatter: ({ value }) => {
        return UserRoleLabel[value];
      },
      flex: 1,
    },
    {
      colId: 'email',
      headerName: t('headerEmail'),
      field: 'email',
      filter: 'agTextColumnFilter',
      flex: 3,
    },
    {
      colId: 'addressName',
      headerName: t('headerLocation'),
      field: 'addressName',
      filter: 'agTextColumnFilter',
      flex: 3,
    },
    {
      colId: 'customerEditAllowed',
      headerName: t('headerEditCustomers'),
      field: 'customerEditAllowed',
      filter: 'agSetColumnFilter',
      filterParams: {
        values: Object.values(SettingValue),
        valueFormatter: ({ value }) => SettingValueLabel[value],
      },
      filterValueGetter: ({ data }) =>
        data?.customerEditAllowed ? SettingValue.ENABLED : SettingValue.DISABLED,
      cellRenderer: SwitchCell,
      cellRendererParams: {
        colId: 'customerEditAllowed',
        isEditable: (data: IProjectUser) => !data?.isOwner,
      },
      enableRowGroup: false,
      flex: 2,
    },
    {
      colId: 'pricingEditAllowed',
      headerName: t('headerEditPricing'),
      field: 'pricingEditAllowed',
      filter: 'agSetColumnFilter',
      filterParams: {
        values: Object.values(SettingValue),
        valueFormatter: ({ value }) => SettingValueLabel[value],
      },
      filterValueGetter: ({ data }) =>
        data?.pricingEditAllowed ? SettingValue.ENABLED : SettingValue.DISABLED,
      cellRenderer: SwitchCell,
      cellRendererParams: {
        colId: 'pricingEditAllowed',
        isEditable: (data: IProjectUser) => !data?.isOwner,
      },
      enableRowGroup: false,
      flex: 2,
    },
    {
      colId: 'notificationsEnabled',
      headerName: t('headerNotifications'),
      field: 'notificationsEnabled',
      filter: 'agSetColumnFilter',
      filterParams: {
        values: Object.values(SettingValue),
        valueFormatter: ({ value }) => {
          return SettingValueLabel[value];
        },
      },
      filterValueGetter: ({ data }) =>
        data?.notificationsEnabled ? SettingValue.ENABLED : SettingValue.DISABLED,
      cellRenderer: SwitchCell,
      cellRendererParams: {
        colId: 'notificationsEnabled',
        isEditable: (data: IProjectUser) => !data?.isOwner,
      },
      enableRowGroup: false,
      flex: 2,
    },
  ];
};
